import { initialState } from "./state"

export default {
  updateUuid: (state, payload) => (state.uuid = payload),
  updateCurrentStep: (state, payload) => (state.currentStep = payload),
  updateIsEditing: (state, payload) => (state.isEditing = payload),
  updateRole: (state, payload) => (state.role = { ...state.role, ...payload }),
  setRole: (state, payload) => (state.role = payload),
  updateName: (state, payload) => (state.role.name = payload),
  updateLevel: (state, payload) => (state.role.level = payload),
  updateCategory: (state, payload) => (state.role.category = payload),
  updateActive: (state, payload) => (state.role.active = payload),
  updateSearchable: (state, payload) => (state.role.searchable = payload),
  updateAccessControl: (state, payload) => (state.role.accessControl = payload),
  updateCanSell: (state, payload) => (state.role.canSell = payload),
  updateAccessWithoutGeolocation: (state, payload) => (state.role.accessWithoutGeolocation = payload),
  updatePermissions: (state, payload) =>
    (state.permissions = [...state.permissions, ...payload]),
  setPermissions: (state, payload) => (state.permissions = payload),
  setMenuPermissions: (state, payload) => (state.menuPermissions = payload),
  setHomePermissions: (state, payload) => (state.homePermissions = payload),
  setPermissionsOptions: (state, payload) =>
    (state.permissionsOptions = payload),
  setMenuPermissionsOptions: (state, payload) =>
    (state.menuPermissionsOptions = payload),
  setHomePermissionsOptions: (state, payload) =>
    (state.homePermissionsOptions = payload),
  setReportPermissionsOptions: (state, payload) =>
    (state.reportPermissionsOptions = payload),
  clearRoleStore: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
